import recaptcha from './recaptcha';
import view from './view';

export default {
  load: recaptcha.load,
  make: view.make,
};
